import { useState, useEffect, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleTestimonialsClick = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault();
      navigate('/#testimonials');
    },
    [navigate]
  );

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-2 cursor-pointer">
            <div className="w-10 h-10 flex items-center justify-center">
              <i className={`ri-plant-line text-3xl ${isScrolled ? 'text-emerald-600' : 'text-white'}`}></i>
            </div>
            <span className={`text-2xl font-serif font-bold ${isScrolled ? 'text-gray-900' : 'text-white'}`}>
              GreenEmbers
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link to="/" className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              isScrolled ? 'text-gray-700 hover:text-emerald-600' : 'text-white hover:text-emerald-200'
            }`}>
              Home
            </Link>
            <Link to="/login" className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              isScrolled ? 'text-gray-700 hover:text-emerald-600' : 'text-white hover:text-emerald-200'
            }`}>
              Services
            </Link>
            <a href="/#testimonials" onClick={handleTestimonialsClick} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              isScrolled ? 'text-gray-700 hover:text-emerald-600' : 'text-white hover:text-emerald-200'
            }`}>
              Testimonials
            </a>
            <Link to="/contact" className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              isScrolled ? 'text-gray-700 hover:text-emerald-600' : 'text-white hover:text-emerald-200'
            }`}>
              Contact
            </Link>
            <Link to="/careers" className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              isScrolled ? 'text-gray-700 hover:text-emerald-600' : 'text-white hover:text-emerald-200'
            }`}>
              Careers
            </Link>
            <Link to="/login" className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              isScrolled ? 'text-gray-700 hover:text-emerald-600' : 'text-white hover:text-emerald-200'
            }`}>
              Login
            </Link>
            <Link to="/contact" className="px-6 py-2.5 bg-emerald-600 text-white text-sm font-medium rounded-lg hover:bg-emerald-700 transition-colors whitespace-nowrap cursor-pointer">
              Inquire
            </Link>
          </div>

          <button 
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <i className={`ri-menu-line text-2xl ${isScrolled ? 'text-gray-900' : 'text-white'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200">
          <div className="px-6 py-4 space-y-3">
            <Link to="/" className="block text-sm font-medium text-gray-700 hover:text-emerald-600 cursor-pointer">
              Home
            </Link>
            <Link to="/login" className="block text-sm font-medium text-gray-700 hover:text-emerald-600 cursor-pointer">
              Services
            </Link>
            <a href="/#testimonials" onClick={handleTestimonialsClick} className="block text-sm font-medium text-gray-700 hover:text-emerald-600 cursor-pointer">
              Testimonials
            </a>
            <Link to="/contact" className="block text-sm font-medium text-gray-700 hover:text-emerald-600 cursor-pointer">
              Contact
            </Link>
            <Link to="/careers" className="block text-sm font-medium text-gray-700 hover:text-emerald-600 cursor-pointer">
              Careers
            </Link>
            <Link to="/login" className="block text-sm font-medium text-gray-700 hover:text-emerald-600 cursor-pointer">
              Login
            </Link>
            <Link to="/contact" className="block w-full text-center px-6 py-2.5 bg-emerald-600 text-white text-sm font-medium rounded-lg hover:bg-emerald-700 transition-colors whitespace-nowrap cursor-pointer">
              Inquire
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}